import React from 'react';
import Styles from './FormBasicInfo.css';
import clsx from 'clsx';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import ButtonCard from '../../widgets/ButtonCard/ButtonCard';
import { Controller } from 'react-hook-form';
import Select from '../../widgets/Select/Select';
import { combineFieldProps } from '../../shared/utils/form';
import TextField from '../../widgets/TextField/TextField';
import Checkbox from '../../widgets/Checkbox/Checkbox';
import Button from '../../widgets/Button/Button';
import ModalApartamento from '../ModalApartamento/ModalApartamento';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import { useFormInitialData } from '../../model/form-initial-data';
import { Divider } from '../../widgets/Divider/Divider';
import CardStore from '../../widgets/CardStore/CardStore';
import FormUsage from '../FormUsage/FormUsage';
import SelectStore from '../../widgets/Select/SelectStore';

function FormBasicInfo() {
  const state = useSimuladorEnergiaSolarState();
  const form = useFormInitialData();

  const visible = state.simulationStep?.id === SIMULATION_STEPS.FORM_BASIC_INFO.id;

  return (
    <>
      <div
        id="form-basic-info"
        className={clsx({
          info: true,
          hidden: !visible,
          'loading-stores': form.loadingStores,
          'has-store-results':
            state.isMobile &&
            form.addressCompleted &&
            form.searchStoreResults &&
            !!form.currentStore &&
            form.currentStore != '0',
        })}
      >
        <ContainerHome24>
          <h2 className="info-title">Onde você quer investir em energia limpa?</h2>
          <p className="info-subtitle">Selecione qual a sua residência:</p>

          <div className="button-row">
            <ButtonCard
              icon="assets/simulador-energia-solar/jornada/ic-casa.svg"
              text="Casa"
              selected={state.residencyType === 'home'}
              onClick={() => {
                state.setResidencyType('home');
              }}
            />
            <ButtonCard
              icon="assets/simulador-energia-solar/jornada/ic-apartamento.svg"
              text="Apartamento"
              selected={state.residencyType === 'apartment'}
              onClick={() => {
                state.setResidencyType('apartment');
                state.setModalApartmentOpen(true);

                if (process.env.NODE_ENV === 'development') {
                  state.setSimulationType(null);
                }
              }}
            />
          </div>

          {state.residencyType === 'home' && (
            <>
              <Divider />
              <p className="text-rooftype">Você tem algum orçamento de placa solar?</p>

              <div className="simulation-type-wrapper">
                <Checkbox
                  variant="radio"
                  label="Sim, já tenho um orçamento"
                  checked={state.simulationType === 'existing'}
                  handleChange={(c) => {
                    if (!c) return;
                    state.setSimulationType('existing');
                  }}
                />
                <Checkbox
                  variant="radio"
                  label="Não, estou somente pesquisando"
                  checked={state.simulationType === 'new'}
                  handleChange={(c) => {
                    if (!c) return;
                    state.setSimulationType('new');
                  }}
                />
              </div>

              {state.hasSelectedType && (
                <p className="text-informative">
                  {state.simulationType === 'existing' && (
                    <>Legal! Conta pra gente mais sobre o seu projeto:</>
                  )}
                  {state.simulationType === 'new' && (
                    <>Você está no lugar certo! Acharemos um parceiro para sua simulação:</>
                  )}
                </p>
              )}

              <form
                className={clsx('form-render', state.hasSelectedType && 'has-selected')}
                onSubmit={form.handleSubmit}
              >
                {state.hasSelectedType &&
                  form.fields.map((field) => {
                    return (
                      <Controller
                        key={`field-${field.name}`}
                        name={field.name}
                        control={form.form.control}
                        render={(renderOptions) => {
                          const isSearch = field.name === 'searchStore';
                          const isSelect = field.type === 'select';
                          const isPostalCode = field.name === 'postalCode';
                          const isAddressNumber = field.name === 'addressNumber';
                          const fieldProps = combineFieldProps(field, renderOptions);

                          if (isSearch && form.loadingStores) {
                            fieldProps.helperText = '';
                            fieldProps.error = false;
                          }

                          return (
                            <div
                              className={clsx({
                                'field-wrapper': true,
                                [`field-${fieldProps.name}`]: true,
                                'has-value': !!renderOptions.field.value,
                              })}
                            >
                              {!!field.extraLabel && (
                                <>
                                  {field.extraLabelHtml ? (
                                    <p
                                      className="text-extra-label"
                                      dangerouslySetInnerHTML={{ __html: field.extraLabel }}
                                    />
                                  ) : (
                                    <p className="text-extra-label">{field.extraLabel}</p>
                                  )}
                                </>
                              )}

                              {isSelect && (
                                <>
                                  {field.name === 'store' ? (
                                    <>
                                      {visible && (
                                        <SelectStore
                                          {...fieldProps}
                                          touched={
                                            renderOptions.fieldState.isTouched ||
                                            renderOptions.formState.submitCount > 0 ||
                                            renderOptions.formState.isSubmitted
                                          }
                                          handleValueChange={(v) => {
                                            form.form.setValue(field.name, v, {
                                              shouldDirty: true,
                                              shouldTouch: true,
                                              shouldValidate: true,
                                            });
                                          }}
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <Select
                                      {...fieldProps}
                                      handleValueChange={(v) => {
                                        form.form.setValue(field.name, v, {
                                          shouldDirty: true,
                                          shouldTouch: true,
                                          shouldValidate: true,
                                        });
                                      }}
                                      startAdornment={
                                        isSearch && !renderOptions.field.value ? (
                                          <img
                                            alt="buscar"
                                            src="assets/simulador-energia-solar/jornada/ic-search.svg"
                                          />
                                        ) : null
                                      }
                                    />
                                  )}
                                </>
                              )}

                              {!isSelect && <TextField {...fieldProps} />}

                              {isAddressNumber && (
                                <Checkbox
                                  id="chk-sem-numero"
                                  checked={form.isNoAddressNumberChecked}
                                  handleChange={(checked) => {
                                    form.form.setValue('noAddressNumber', checked, true);

                                    if (checked && renderOptions.field.value !== '') {
                                      form.form.setValue(field.name, '', true);
                                    }

                                    if (checked) {
                                      form.form.clearErrors(field.name);
                                    }
                                  }}
                                  label="Sem número"
                                />
                              )}

                              {isPostalCode && (
                                <a
                                  id="cta-nao-sei-cep"
                                  href={
                                    state.linkFindCEP || 'https://buscacepinter.correios.com.br'
                                  }
                                  rel="noreferrer"
                                  target="_blank"
                                >
                                  Não sei meu CEP
                                </a>
                              )}
                            </div>
                          );
                        }}
                      />
                    );
                  })}

                {form.addressCompleted &&
                  form.searchStoreResults &&
                  state.simulationType === 'new' && (
                    <div className="store-results-container">
                      {form.searchStoreResults.map((store) => {
                        const checked = `${form.currentStore}` === `${store.id}`;

                        return (
                          <CardStore
                            {...store}
                            areaClickable
                            key={`store-${store.id || store.storeEntryId}`}
                            checked={checked}
                            handleCheckedChange={(v) => {
                              form.form.setValue('store', v ? `${store.id}` : '0', true);

                              if (state.simulationType === 'new' && form.addressCompleted) {
                                form.form.setError('searchStore', '', true);
                              }
                            }}
                          />
                        );
                      })}
                    </div>
                  )}

                <div className="button-row-form">
                  <Button
                    disabled={form.loading}
                    variant="white"
                    onClick={(ev) => {
                      ev.preventDefault();
                      form.handleBackButton();
                    }}
                  >
                    Voltar
                  </Button>
                  {state.hasSelectedType && (
                    <Button
                      disabled={form.loading}
                      loading={form.loading}
                      variant="red"
                      type="submit"
                      onClick={(ev) => {
                        form.handleSubmit(ev);
                      }}
                    >
                      Continuar
                    </Button>
                  )}
                </div>
              </form>
            </>
          )}

          {state.residencyType === 'apartment' && <ModalApartamento />}
        </ContainerHome24>
      </div>

      <FormUsage formUsage={form} />
      <style jsx>{Styles}</style>
    </>
  );
}

export default FormBasicInfo;
